import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { tenantConfigurationService } from "../api/services/tenantConfigurationService";
import { TenantConfiguration } from "../schemas/tenantConfigurationSchema";

export const useTenantConfiguration = (tenantId?: string) => {
  const queryClient = useQueryClient();

  const {
    data: configuration,
    isLoading,
    refetch,
  } = useQuery<TenantConfiguration | null, Error>({
    queryKey: ["tenant-configuration", tenantId],
    queryFn: () => {
      if (!tenantId) return Promise.resolve(null);
      return tenantConfigurationService.getByTenantId(tenantId);
    },
    enabled: !!tenantId,
  });

  const updateConfigurationMutation = useMutation({
    mutationFn: tenantConfigurationService.update,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["tenant-configuration", tenantId],
      });
      toast.success("Configuration updated successfully");
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to update configuration");
    },
  });

  return {
    configuration,
    isLoading,
    refetch,
    updateConfiguration: updateConfigurationMutation.mutateAsync,
    isUpdating: updateConfigurationMutation.isPending,
  };
};

